import type { LucideIcon } from 'lucide-react';
import { SiGoogle } from 'react-icons/si';
import {
	CheckCircle2,
	XCircle,
	Shield,
	Building2,
	Briefcase,
	Calendar,
	Monitor,
} from 'lucide-react';

const StatusItem = ({
	label,
	value,
	icon: Icon,
	active,
}: {
	label: string;
	value: string;
	icon: LucideIcon | typeof SiGoogle;
	active: boolean;
}) => (
	<div className="flex h-[56px] w-full min-w-0 items-center gap-3 rounded-2xl border border-zinc-100 bg-zinc-50 px-4 py-2 transition-all hover:bg-zinc-100">
		<div
			className={`shrink-0 rounded-lg p-1.5 ${
				active ? 'bg-zinc-900 text-white' : 'bg-zinc-200 text-zinc-500'
			}`}
		>
			<Icon size={14} />
		</div>
		<div className="flex min-w-0 flex-1 flex-col justify-center overflow-hidden">
			<span className="text-[9px] font-bold uppercase tracking-wider text-zinc-400">
				{label}
			</span>
			<span className="truncate text-xs font-bold text-zinc-900">
				{value}
			</span>
		</div>
	</div>
);

interface ProfessionalDetailTagsProps {
	serviceModality?: string;
	clinicName?: string;
	serviceName?: string;
	createdAt?: string;
	googlePermissionsAllowed?: boolean;
	verifiedEmail?: boolean;
	last_login?: string;
	updatedAt?: string;
	authorized?: boolean;
}

const ProfessionalDetailTags = ({
	serviceModality,
	clinicName,
	serviceName,
	createdAt,
	googlePermissionsAllowed,
	verifiedEmail,
	last_login,
	updatedAt,
	authorized,
}: ProfessionalDetailTagsProps) => (
	<div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
		{serviceModality && (
			<StatusItem
				label="Modalidade"
				value={serviceModality ?? '-'}
				icon={Monitor}
				active={!!serviceModality}
			/>
		)}

		{clinicName && (
			<StatusItem
				label="Clínica"
				value={clinicName ?? '-'}
				icon={Building2}
				active={!!clinicName}
			/>
		)}
		{serviceName && (
			<StatusItem
				label="Serviço prestado"
				value={serviceName ?? '-'}
				icon={Briefcase}
				active={!!serviceName}
			/>
		)}
		{typeof authorized === 'boolean' && (
			<StatusItem
				label="Autorização"
				value={authorized ? 'Autorizado' : 'Não autorizado'}
				icon={Calendar}
				active={authorized}
			/>
		)}
		{createdAt && (
			<StatusItem
				label="Cadastro"
				value={createdAt ?? '-'}
				icon={Calendar}
				active={!!createdAt}
			/>
		)}

		{last_login && (
			<StatusItem
				label="Ultimo acesso"
				value={last_login ?? '-'}
				icon={Calendar}
				active={!!last_login}
			/>
		)}

		{updatedAt && (
			<StatusItem
				label="Editado em"
				value={updatedAt ?? '-'}
				icon={Calendar}
				active={!!updatedAt}
			/>
		)}
		{typeof googlePermissionsAllowed === 'boolean' && (
			<StatusItem
				label="Permissão de Dados do Google"
				value={
					googlePermissionsAllowed
						? 'Permissões concedidas no Google'
						: 'Permissões não concedidas no Google'
				}
				icon={googlePermissionsAllowed ? CheckCircle2 : XCircle}
				active={googlePermissionsAllowed}
			/>
		)}

		{typeof verifiedEmail === 'boolean' && (
			<StatusItem
				label="Verificação de E-mail"
				value={
					verifiedEmail
						? 'Verificado pelo Google'
						: 'E-mail não verificado pelo Google'
				}
				icon={verifiedEmail ? SiGoogle : Shield}
				active={verifiedEmail}
			/>
		)}
	</div>
);

export { ProfessionalDetailTags };
